import { useNavigate } from 'react-router-dom';

import { useQuery } from '@tanstack/react-query';

import { getTerminal } from 'api/Terminal';

import { DEFAULT_QUERY_OPTIONS } from 'lib/constants/queries/defaultQueryOptions';

export const useTerminal = ({ params = {}, options = {}, dependencies = [] }) => {
  const navigate = useNavigate();

  return useQuery(['terminal', ...dependencies], () => getTerminal(navigate, params), {
    ...DEFAULT_QUERY_OPTIONS,
    ...options
  });
};
